import {
  GET_SUBSCRIPTION_PLANS,
  GET_SUBSCRIPTION_PLANS_SUCCESS,
  GET_SUBSCRIPTION_PLANS_ERROR,
} from "../../constants/actionTypes";

export const subscriptionInitialState = {
  isFetching: true,
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_SUBSCRIPTION_PLANS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_SUBSCRIPTION_PLANS_SUCCESS: {
      return {
        ...state,
        plans: payload.sort((a, b) => b.numericPrice - a.numericPrice),
        isFetching: false,
      };
    }
    case GET_SUBSCRIPTION_PLANS_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
